<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div v-for="(trust, index) in trusts" :key="index">
        <div class="list-item">
          <v-btn
            class="list-item-btn"
            :ripple="false"
            block
            color="white"
            @click.stop="(showDialog = true), (trustToUpdate = trust)"
          >
            <div class="list-item-text">
              <span class="list-item-name">{{ trust.name }}</span>
              <span v-if="trust.incorporationNumber" class="list-item-separator"
                >-</span
              >
              <span class="list-item-more-info">{{
                trust.incorporationNumber
              }}</span>
              <BeneficiaryDonationDetails :beneficiary="trust" />
            </div>
          </v-btn>
        </div>
      </div>
      <div class="mt-5 mb-5">
        <AlternativeButton
          :title="'Add Trust'"
          @gradientButtonClicked="addTrustClicked"
        />
      </div>
    </v-col>
    <TrustDialog v-model="showDialog" :trust-to-update="trustToUpdate" />
  </v-row>
</template>

<script>
  import TrustDialog from './TrustDialog.vue';
  import BeneficiaryDonationDetails from './BeneficiaryDonationDetails';

  export default {
    name: 'TrustsList',
    components: {
      TrustDialog,
      BeneficiaryDonationDetails,
    },
    props: {
      trusts: {
        required: true,
        type: Array,
      },
    },
    data() {
      return {
        showDialog: false,
        trustToUpdate: {},
      };
    },
    methods: {
      addTrustClicked() {
        this.trustToUpdate = {};
        this.showDialog = true;
        this.sendGADataLayer('your-people-add-new-trust');
      },
      sendGADataLayer(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: event,
          omuserid: this.$store.getters?.userId,
        });
      },
    },
  };
</script>
